document.addEventListener('DOMContentLoaded', function () {
  // FV内のfade要素をページ読み込み時に即座に表示（スクロール不要）
  document.querySelectorAll('.fv > .fade').forEach(function (el) {
    el.classList.add('show');
  });

  const smoothScrollTrigger = document.querySelectorAll('a[href^="#"]');
  for (let i = 0; i < smoothScrollTrigger.length; i++) {
    smoothScrollTrigger[i].addEventListener('click', (e) => {
      e.preventDefault();
      let href = smoothScrollTrigger[i].getAttribute('href');
      let targetElement = document.getElementById(href.replace('#', ''));
      document.querySelector("#hamburg-menu-btn").checked = false;
      if (!targetElement) return;
      const rect = targetElement.getBoundingClientRect().top;
      const offset = window.pageYOffset;
      const gap = 0;
      const target = rect + offset - gap;
      window.scrollTo({
        top: target,
        behavior: 'smooth',
      });
    });
  }

  if (document.querySelector('.original-items__carousel .swiper') != null) {
    let swiperParams = {
      loop: true,
      slidesPerView: 1,
      speed: 800,
      spaceBetween: 30,
    };
    swiperParams.autoplay = {
      delay: 3000,
    };
    swiperParams.pagination = {
      el: `.swiper-pagination`,
      clickable: true,
    };
    swiperParams.navigation = {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    };
    var swiperEl = document.querySelector(`.original-items__carousel .swiper`);
    var swiper = new Swiper(swiperEl, swiperParams);
    swiper.autoplay.stop();

    // アクティブスライドに合わせて右上の番号SVG(_number_01〜11)を差し替える
    var numberEl = document.querySelector('.original-items__number');
    var updateNumber = function () {
      if (!numberEl) return;
      var n = String(swiper.realIndex + 1).padStart(2, '0');
      numberEl.src = numberEl.src.replace(/(_number_)\d+(\.svg)/, '$1' + n + '$2');
    };
    swiper.on('slideChange', updateNumber);
    updateNumber();

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            swiper.autoplay.start();
            observer.disconnect();
          }
        });
      }, { threshold: 0.3 });
      observer.observe(swiperEl);
    } else {
      // IntersectionObserver非対応環境ではフォールバックとして即開始
      swiper.autoplay.start();
    }
  };

  const faqQuestions = document.querySelectorAll('.qa__question');
  faqQuestions.forEach(function (question) {
    question.addEventListener('click', function () {
      let nextElement = this.nextElementSibling;
      if (nextElement.style.display === 'none' || nextElement.style.display === '') {
        nextElement.style.display = 'block';
      } else {
        nextElement.style.display = 'none';
      }
      this.classList.toggle('is-active');
      return false;
    });
  });
});